/* hs-eslint ignored failing-rules */
/* eslint-disable compat/compat */

'use es6';

import { FETCH_GENERATED_LAYOUT_HUBL_STARTED, FETCH_GENERATED_LAYOUT_HUBL_SUCCESS, FETCH_GENERATED_LAYOUT_HUBL_FAILURE } from 'ContentEditorUI/redux/actions/actionTypes';
import { getCurrentCopyFragmentAsHublInfo } from 'ContentEditorUI/redux/selectors/sectionsSelectors';
import { getLayoutSectionTreeById } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { exportTreeFragmentAsLayoutDataJson, getNodeType } from 'ContentEditorUI/utils/layoutSectionTreeUtils';
import { fetchHubl } from 'ContentEditorUI/api/HublApi';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import logSeleniumEvent from 'ContentEditorUI/utils/logSeleniumEvent';
import CopyAsHublFallbackAlert from '../../components/CopyAsHublFallbackAlert';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { jsx as _jsx } from "react/jsx-runtime";
export const fetchGeneratedLayoutHublSuccess = resp => dispatch => {
  logSeleniumEvent('hublCopiedToClipboard', resp);
  navigator.clipboard.writeText(resp).then(() => {
    dispatch({
      type: FETCH_GENERATED_LAYOUT_HUBL_SUCCESS
    });
  }).catch(err => {
    FloatingAlertStore.addAlert({
      id: 'copy-as-hubl-fallback',
      sticky: true,
      message: /*#__PURE__*/_jsx(CopyAsHublFallbackAlert, {
        hubl: resp
      }),
      onClose: () => {
        console.error(err);
        dispatch({
          type: FETCH_GENERATED_LAYOUT_HUBL_FAILURE
        });
      }
    });
  });
};
export const fetchGeneratedLayoutHublFailure = error => {
  console.log(error);
  return {
    type: FETCH_GENERATED_LAYOUT_HUBL_FAILURE
  };
};
export const startGeneratedHublRequest = (sectionName, layoutSectionId) => {
  return {
    type: FETCH_GENERATED_LAYOUT_HUBL_STARTED,
    payload: {
      sectionName,
      layoutSectionId
    }
  };
};
export const fetchAndCopyGeneratedHubl = () => (dispatch, getState) => {
  const state = getState();

  // Get the current row id and layout section id we care about
  const currentCopyFragmentAsHublInfo = getCurrentCopyFragmentAsHublInfo(state);
  const {
    sectionName,
    layoutSectionId
  } = currentCopyFragmentAsHublInfo;
  const targetLayoutSectionTree = getLayoutSectionTreeById(state, {
    layoutSectionId
  });
  let sectionNode;
  if (targetLayoutSectionTree.hasCell(sectionName)) {
    sectionNode = targetLayoutSectionTree.findCell(sectionName);
  } else if (targetLayoutSectionTree.hasRow(sectionName)) {
    sectionNode = targetLayoutSectionTree.findRow(sectionName);
  } else {
    throw Error(`Can't find fragment ${sectionName} in ${targetLayoutSectionTree.getName()}`);
  }
  const nodeType = getNodeType(sectionNode).toUpperCase();
  UsageTracker.trackEditorInteraction({
    action: 'Developer Mode',
    event: `copy-${nodeType}-as-hubl`
  });

  // Get the JSON representation of the layout tree
  const sectionTree = exportTreeFragmentAsLayoutDataJson(sectionNode);
  const sectionToSend = {
    rootTag: nodeType,
    layoutTree: sectionTree
  };
  fetchHubl(sectionToSend).then(resp => dispatch(fetchGeneratedLayoutHublSuccess(resp)), error => dispatch(fetchGeneratedLayoutHublFailure(error))).catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
};